import { styled } from 'stitches.config'

export const Span = styled('span', {
  variants: {
    weight: {
      regular: {
        fontWeight: '$regular',
      },
      medium: {
        fontWeight: '$semiBold',
      },
      bold: {
        fontWeight: '$semiBold',
      },
    },
    italic: {
      true: {
        fontStyle: 'italic',
      },
    },
    underline: {
      true: {
        textDecoration: 'underline',
      },
    },
  },
  defaultVariants: {
    weight: 'regular',
    italic: false,
    underline: false,
  },
})

export const PostContentRoot = styled('div', {
  '& h3 + p': {
    marginTop: '$3',
  },
  '& p + p': {
    marginTop: '$2',
  },
  '& p + h3': {
    marginTop: '$4',
  },
})
